export default __webpack_public_path__ + "static/logo_cloudhunters-e75f683a17f19b4507b2c1edabf48e65.png";